import React from 'react';
import PropTypes from 'prop-types';
import { TransitionMotion } from 'react-motion';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants';
import { springify } from '../../lib/Motion';
import { propsEqual, MyPureComponent } from '../../lib/react';

const optionsShape = {
  precision: PropTypes.number,
  stiffness: PropTypes.number,
  damping: PropTypes.number,
};

class ElementTransition extends MyPureComponent {
  static propTypes = {
    element: PropTypes.element,
    id: PropTypes.string.isRequired,
    baseStyle: PropTypes.object,
    styleEnter: PropTypes.object,
    styleShown: PropTypes.object,
    styleLeave: PropTypes.object,
    options: PropTypes.shape(optionsShape),
    optionsShown: PropTypes.shape(optionsShape),
    optionsLeave: PropTypes.shape(optionsShape),
    onStartLeave: PropTypes.func,
    onEndLeave: PropTypes.func,
    onStartEnter: PropTypes.func,
  };
  static defaultProps = {
    element: null,
    styleEnter: { opacity: 0 },
    styleShown: { opacity: 1 },
    styleLeave: { opacity: 0 },
    options: EMPTY_OBJECT,
    optionsShown: EMPTY_OBJECT,
    optionsLeave: EMPTY_OBJECT,
    onStartLeave: () => {},
    onEndLeave: () => {},
    onStartEnter: () => {},
  };

  constructor(props) {
    super(props);

    this.entering = undefined;
    this.leaving = undefined;

    this.state = {
      styleLeave: EMPTY_OBJECT,
      currentElementData: EMPTY_ARRAY,
      ...this.processNewProps(EMPTY_OBJECT, props),
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.processNewProps(this.props, nextProps));
  }

  processNewProps = (props, nextProps) => {
    let stateUpdate = {};

    if (!propsEqual(props, nextProps, ['id'])) {
      if (props.element) {
        this.triggerStartLeave();
      } else if (nextProps.element) {
        this.triggerStartEnter();
      }
    }

    if (
      !propsEqual(props, nextProps, ['styleLeave', 'options', 'optionsLeave'])
    ) {
      stateUpdate['styleLeave'] = {
        ...nextProps.styleLeave,
        ...springify(nextProps.styleLeave, {
          ...nextProps.options,
          ...nextProps.optionsLeave,
        }),
      };
    }

    if (
      !propsEqual(props, nextProps, [
        'id',
        'element',
        'styleShown',
        'options',
        'optionsShown',
      ])
    ) {
      stateUpdate['currentElementData'] = [
        {
          key: nextProps.id,
          data: nextProps.element,
          style: {
            ...nextProps.styleShown,
            ...springify(nextProps.styleShown, {
              ...nextProps.options,
              ...nextProps.optionsShown,
            }),
          },
        },
      ];
    }

    return stateUpdate;
  };

  triggerStartEnter = () => {
    if (!this.entering) {
      this.entering = true;
      setTimeout(this.props.onStartEnter, 0);
    }
  };

  triggerStartLeave = () => {
    if (!this.leaving) {
      this.leaving = true;
      this.entering = false;
      setTimeout(this.props.onStartLeave, 0);
    }
  };

  triggerEndLeave = () => {
    if (this.leaving) {
      this.leaving = false;
      setTimeout(this.props.onEndLeave, 0);
    }
  };

  getEnterStyle = () => {
    return this.props.styleEnter;
  };

  getLeaveStyle = () => {
    return this.state.styleLeave;
  };

  getStyles = tweeningStyles => {
    if (
      tweeningStyles === undefined ||
      tweeningStyles.length < 1 ||
      tweeningStyles[0].key === this.props.id
    ) {
      return this.state.currentElementData;
    }
    return EMPTY_ARRAY;
  };

  render() {
    const {
      element,
      id,
      baseStyle,
      styleEnter,
      styleShown,
      styleLeave,
      options,
      optionsShown,
      optionsLeave,
      onStartLeave,
      onEndLeave,
      onStartEnter,
      ...otherProps
    } = this.props;

    return (
      <TransitionMotion
        willEnter={this.getEnterStyle}
        willLeave={this.getLeaveStyle}
        styles={this.getStyles}
      >
        {tweens => {
          return (
            <div>
              {tweens.map(tween => {
                if (tween.key === id) {
                  if (this.leaving) {
                    this.triggerEndLeave();
                  } else {
                    this.triggerStartEnter();
                  }
                }

                if (tween.key === undefined) {
                  return null;
                } else {
                  return (
                    <div
                      key={tween.key}
                      style={{
                        ...baseStyle,
                        ...tween.style,
                        pointerEvents:
                          tween.style.opacity < 0.5 ? 'none' : undefined,
                      }}
                    >
                      {tween.data}
                    </div>
                  );
                }
              })}
            </div>
          );
        }}
      </TransitionMotion>
    );
  }
}

export default ElementTransition;



// WEBPACK FOOTER //
// ./src/components/ElementTransition/ElementTransition.js